import React from 'react';

import "./core-arrow2.css"

const coreArrow2 = (props: coreArrow2Config) => {
	return (
		<div className='core-arrow2-arrow-container'>
			<div className='core-arrow2-arrow-head'>

			</div>
			<div className='core-arrow2-arrow-tail center-element'>

			</div>
		</div>
	);

};

export interface coreArrow2Config {
}

export default coreArrow2;